import { Dispatch } from 'redux';
import { LoginService } from "../../services/LoginService";
import { adminapi } from "../../ApiNames";

type Nullable<T> = T | null;

export const fetchdatasuccess = (data:any)=>({
    type : 'fetch_data_success',
    payload:data
});
export const AddDataSuccess = (data: any) => ({
    type: 'ADD_DATA_SUCCESS',
    payload: data,
});
export const EditDataSuccess = (editdata: any) => ({
    type: 'EDIT_DATA_SUCCESS',
    payload: editdata,
});
export const DeleteDataSuccess = (deletedata: any) => ({
    type: 'DELETE_DATA_SUCCESS',
    payload: deletedata,
});

export const fetchdata = (uid:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            const payload = {userid:uid};
            const apiname = adminapi.adcountry
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchdatasuccess(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    }
};
export const AddCountriesData = (CountryName: string) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { q: 1, needtype: CountryName };
            const apiname = adminapi.ad_addcountry;
            const response = await LoginService.getData(apiname,payload);
            dispatch(AddDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const CountriesEditData = (CountryName: string,id:number) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { q: 2, cname: CountryName,cid:id };
            const apiname = adminapi.ad_addcountry;
            const response = await LoginService.getData(apiname,payload);
            dispatch(EditDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const DeleteData = ( id:string) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { q: 3,cid:id};
            const apiname = adminapi.ad_addcountry;
            const response = await LoginService.getData(apiname,payload);
            dispatch(DeleteDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};